// Add a request interceptor
window.axios.interceptors.request.use(function (config) {
    window.app.$Progress.start(); // for every request start the progress
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Add a response interceptor
window.axios.interceptors.response.use(function (response) {
    hideSkeleton();    

    window.app.$Progress.finish(); // finish when a response is received

    return response;
}, function (error) {
    hideSkeleton();    
    
    window.app.$Progress.finish(); // finish when a response is received

    // Check if error.response exists before accessing its properties
    if (error.response && error.response.status === 401) {
        // Only redirect to login if it's a critical API call that requires authentication
        // Don't redirect for optional calls like checking existing bookings
        const url = error.config?.url || '';
        const isCriticalCall = url.includes('/api/book_tickets') || 
                              url.includes('/api/mercadopago/process') || 
                              url.includes('/mybookings') ||
                              url.includes('/dashboard');
        
        if (isCriticalCall) {
            window.location.href = route('eventmie.login');
            Vue.helpers.showToast('error', trans('em.please_login'));
        }
        return Promise.reject(error);
    }

    // Mostrar erros de validação (Laravel) sem quebrar o objeto do Axios.
    if (error.response && error.response.status === 422 && error.response.data && error.response.data.errors) {
        Vue.helpers.axiosErrors(error);
    }

    return Promise.reject(error);
});

function hideSkeleton() {
    [].forEach.call(document.querySelectorAll('.skeleton-loader'), function (el) {
        el.style.display = 'none';
    });
}